export const AuthLayout = () =>
  import(/* webpackChunkName: "auth" */ '@/layouts/AuthLayout');
